import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AreaGrecanicaComponent } from './area-grecanica/area-grecanica.component';
import { AreeMarineProtetteComponent } from './aree-marine-protette/aree-marine-protette.component';
import { ArteSpiritualitaSilaComponent } from './arte-spiritualita-sila/arte-spiritualita-sila.component';
import { AspromonteComponent } from './aspromonte/aspromonte.component';
import { AvventuraUmanaComponent } from './avventura-umana/avventura-umana.component';
import { BorghiStoriciComponent } from './borghi-storici/borghi-storici.component';
import { CamminiOutdoorComponent } from './cammini-outdoor/cammini-outdoor.component';
import { CicloturismoComponent } from './cicloturismo/cicloturismo.component';
import { CicloviaParchiAspromonteComponent } from './ciclovia-parchi-aspromonte/ciclovia-parchi-aspromonte.component';
import { CicloviaParchiSerreComponent } from './ciclovia-parchi-serre/ciclovia-parchi-serre.component';
import { CulturaArberesheComponent } from './cultura-arbereshe/cultura-arbereshe.component';
import { EsperienzeComponent } from './esperienze/esperienze.component';
import { GeraceComponent } from './gerace/gerace.component';
import { GrifalcoComponent } from './grifalco/grifalco.component';
import { GustoTradizioniComponent } from './gusto-tradizioni/gusto-tradizioni.component';
import { HomepageComponent } from './homepage/homepage.component';
import { ItinerariDidatticiComponent } from './itinerari-didattici/itinerari-didattici.component';
import { LuoghiArteComponent } from './luoghi-arte/luoghi-arte.component';
import { MuseiComponent } from './musei/musei.component';
import { NaturaBenessereComponent } from './natura-benessere/natura-benessere.component';
import { ParchiERiserveComponent } from './parchi-e-riserve/parchi-e-riserve.component';
import { ParchiSilaComponent } from './parchi-sila/parchi-sila.component';
import { ParcoNazionaleComponent } from './parco-nazionale/parco-nazionale.component';
import { PercorsiDiGustoComponent } from './percorsi-di-gusto/percorsi-di-gusto.component';
import { ScopriLaCalabriaComponent } from './scopri-la-calabria/scopri-la-calabria.component';
import { SentieriPatriarchiComponent } from './sentieri-patriarchi/sentieri-patriarchi.component';
import { SerraSanBrunoComponent } from './serra-san-bruno/serra-san-bruno.component';
import { SerreComponent } from './serre/serre.component';
import { SilaComponent } from './sila/sila.component';
import { SitiUnescoComponent } from './siti-unesco/siti-unesco.component';
import { SpiritualitaENaturaComponent } from './spiritualita-e-natura/spiritualita-e-natura.component';
import { StoriaArteSpiritualitaComponent } from './storia-arte-spiritualita/storia-arte-spiritualita.component';
import { StoriciVillaggiComponent } from './storici-villaggi/storici-villaggi.component';
import { StradeParchiComponent } from './strade-parchi/strade-parchi.component';
import { TarsiaFoceCratiComponent } from './tarsia-foce-crati/tarsia-foce-crati.component';
import { ValliCupeComponent } from './valli-cupe/valli-cupe.component';
import { LoginComponent } from './login/login.component';
import { ServiziComponent } from './servizi/servizi.component';
import { OfferteComponent } from './offerte/offerte.component';
import { InfoComponent } from './info/info.component';
import { EventiNewsComponent } from './eventi-news/eventi-news.component';
import { ChiSiamoComponent } from './chi-siamo/chi-siamo.component';
import { CalabriaForKidsComponent } from './calabria-for-kids/calabria-for-kids.component';
import { MappeComponent } from './mappe/mappe.component';

const routes: Routes = [

  {
    path: 'home',
    component: HomepageComponent
  },
  {
    path: 'esperienze',
    component: EsperienzeComponent
  },
  {
    path: 'scopri-la-calabria',
    component: ScopriLaCalabriaComponent
  },
  {
    path: 'parchi-e-riserve',
    component: ParchiERiserveComponent
  },
  {
    path: 'parco-nazionale',
    component: ParcoNazionaleComponent
  },
  {
    path: 'lungo-le-strade-della-ciclovia',
    component: StradeParchiComponent
  },
  {
    path: 'sentieri-patriarchi',
    component: SentieriPatriarchiComponent
  },
  {
    path: 'avventura-umana',
    component: AvventuraUmanaComponent
  },
  {
    path: 'cultura-arbereshe',
    component: CulturaArberesheComponent
  },
  {
    path: 'spiritualita-e-natura',
    component: SpiritualitaENaturaComponent
  },
  {
    path: 'percorsi-di-gusto',
    component: PercorsiDiGustoComponent
  },
  {
    path: 'sila',
    component: SilaComponent
  },
  {
    path: 'parchi-sila',
    component: ParchiSilaComponent
  },
  {
    path: 'storici-villaggi',
    component: StoriciVillaggiComponent
  },
  {
    path: 'arte-spiritualita-sila',
    component: ArteSpiritualitaSilaComponent
  },
  {
    path: 'serre',
    component: SerreComponent
  },
  {
    path: 'ciclovia-parchi-serre',
    component: CicloviaParchiSerreComponent
  },
  {
    path: 'serra-san-bruno',
    component: SerraSanBrunoComponent
  },
  {
    path: 'girifalco',
    component: GrifalcoComponent
  },
  {
    path: 'aspromonte',
    component: AspromonteComponent
  },
  {
    path: 'ciclovia-aspromonte',
    component: CicloviaParchiAspromonteComponent
  },
  {
    path: 'gerace',
    component: GeraceComponent
  },
  {
    path: 'area-grecanica',
    component: AreaGrecanicaComponent
  },
  {
    path: 'valli-cupe',
    component: ValliCupeComponent
  },
  {
    path: 'tarsia-foce-crati',
    component: TarsiaFoceCratiComponent
  },
  {
    path: 'aree-marine-protette',
    component: AreeMarineProtetteComponent
  },
  {
    path: 'cammini-outdoor',
    component: CamminiOutdoorComponent
  },
  {
    path: 'cicloturismo',
    component: CicloturismoComponent
  },
  {
    path: 'natura-e-benessere',
    component: NaturaBenessereComponent
  },
  {
    path: 'storia-arte-e-spiritualita',
    component: StoriaArteSpiritualitaComponent
  },
  {
    path: 'gusto-e-tradizioni',
    component: GustoTradizioniComponent
  },
  {
    path: 'itinerari-didattici',
    component: ItinerariDidatticiComponent
  },
  {
    path: 'siti-unesco',
    component: SitiUnescoComponent
  },
  {
    path: 'borghi-storici',
    component: BorghiStoriciComponent
  },
  {
    path: 'musei-siti-archeologici',
    component: MuseiComponent
  },
  {
    path: 'luohi-arte-storia-spiritualita',
    component: LuoghiArteComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'chi-siamo',
    component: ChiSiamoComponent
  },
  {
    path: 'eventi-news',
    component: EventiNewsComponent
  },
  {
    path: 'info',
    component: InfoComponent
  },
  {
    path: 'offerte',
    component: OfferteComponent
  },
  {
    path: 'servizi',
    component: ServiziComponent
  },
  {
    path: 'calabria-for-kids',
    component: CalabriaForKidsComponent
  },
  {
    path: 'mappe',
    component: MappeComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule { }
